import { useEffect, useState } from 'react'

import Cookies from 'js-cookie'

import { GA_TOKEN_COOKIE } from 'interfaces/constants'
import { checkUntilFinished } from 'utils/subot'

export function useGetEncodedGaId() {
  const [encodedGaId, setEncodedGaId] = useState('')
  const [gaId, setGaId] = useState('')

  useEffect(() => {
    if (!Cookies.get(GA_TOKEN_COOKIE)) {
      checkUntilFinished({
        condition: () => Boolean(Cookies.get(GA_TOKEN_COOKIE)),
        finished: () => {
          const gaClientId = Cookies.get(GA_TOKEN_COOKIE)
          if (gaClientId) {
            const base64Encoded = btoa(gaClientId)
            setEncodedGaId(base64Encoded)
            setGaId(gaClientId)
          }
        },
        // timeout: 10000,
      })
    } else {
      const gaClientId = Cookies.get(GA_TOKEN_COOKIE)
      if (gaClientId) {
        const base64Encoded = btoa(gaClientId)
        setEncodedGaId(base64Encoded)
        setGaId(gaClientId)
      }
    }
  }, [])

  return { encodedGaId, gaId }
}
